import React from 'react';

/**
 * SpynERP Admin Dashboard — platform control panel.
 */
export default function AdminDashboard() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-slate-900">Admin Dashboard</h1>
        <p className="text-slate-600 mt-1">SpynERP platform control panel. Build admin features here.</p>
      </div>
      <div className="rounded-xl border-2 border-dashed border-slate-200 bg-white/50 p-12 text-center">
        <p className="text-slate-500">Admin dashboard content — start developing here.</p>
      </div>
    </div>
  );
}
